<div class="overlay loading" #mainDiv
     [ngClass]="{'visible': isLoading$ | async}">
  <span class="loader"></span>
</div>
